'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitForm = exports.submittedForm = exports.submittingForm = undefined;
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _constants = require('../constants');
var _formInfo = require('../selectors/form-info');
var _activeField = require('../selectors/active-field');
var _validation = require('./validation');
var _snapshot = require('./snapshot');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
var submittingForm = exports.submittingForm = function submittingForm(formId, activeField) {
  return {
    type: _constants.actionTypes.SUBMITTING_FORM,
    formId: formId,
    activeField: activeField
  };
};
var submittedForm = exports.submittedForm = function submittedForm(formId, activeField) {
  return {
    type: _constants.actionTypes.SUBMITTED_FORM,
    formId: formId,
    activeField: activeField
  };
};

// Submit (and optionally validate) whole form
var submitForm = exports.submitForm = function submitForm(formId, validator, callback, singleFieldSubmit, snapshot) {
  return function () {
    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
      var activeField, form, successful;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              activeField = singleFieldSubmit ? (0, _activeField.getActiveField)(getState(), formId) : undefined;
              if (!(!singleFieldSubmit || activeField !== null)) {
                _context.next = 17;
                break;
              }
              dispatch(submittingForm(formId, activeField));
              if (!validator) {
                _context.next = 6;
                break;
              }
              _context.next = 6;
              return dispatch(singleFieldSubmit ? (0, _validation.validateField)(formId, activeField, validator[activeField]) : (0, _validation.validateForm)(formId, validator));
            case 6:
              form = (0, _formInfo.getForm)(getState(), formId);
              successful = false;
              if (!(typeof callback !== 'undefined')) {
                _context.next = 14;
                break;
              }
              _context.next = 11;
              return callback(form);
            case 11:
              successful = _context.sent;
              _context.next = 15;
              break;
            case 14:
              successful = true;
            case 15:
              if (snapshot && successful) {
                dispatch((0, _snapshot.createSnapshot)(formId, activeField));
              }
              dispatch(submittedForm(formId, activeField));
            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};